import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import "../../assets/css/save.css";
import "../../assets/css/favorites.css";
import { API } from "../../services/api";
import Favoritesimg from "../../assets/img/fovr-img.svg"
import MakeFavourite from "../Posts/popups/MakeFavourite";


const Favorites = (props) => {
const navigate = useNavigate();
  const [showfav, setFavourite] = useState(false);
  const [favouriteUserId, setFavouriteUserId] = useState(false);
  const [favourites, setFavourites] = useState({});
  const [FavStatus, setFavStatus] = useState(true);
  
  const showFavourite = (userId) => {
    setFavourite(true);
    setFavouriteUserId(userId);
  }
  const HideFavourite = () => {
    setFavourite(false);
  }
  const toggleFavourite = (userId, newstatus) => {
    const isUsrId = favourites[userId];
    props.getUser()

  };
  const handleImageClick = (first, id) => {
    
     navigate(`/organization/${first}`, { state: { userId: id } })
    
   
  };
  return (
    <div>
      <div className="row">
        {Array.isArray(props.Favorite) && props.Favorite.length > 0 && props.Favorite.map((fav, index) => (
          <div className="col-12 col-sm-6 col-md-4 mb-2" key={fav._id || index}>
            <div className="Favorites-div d-flex justify-content-between align-items-center community-card p-2">
              <div className="d-flex align-items-center gap-2">
                <img
                  src={fav.favouriteMemberId?.profileImage?.url ? API.uploadFilePath + fav.favouriteMemberId?.profileImage?.url : Favoritesimg}
                  alt="test"
                  className="community_thumb" onClick={() => {
                        handleImageClick(fav.favouriteMemberId.firstName,fav.favouriteMemberId._id);
                      }}    
                />
                <span className="letter-width text-truncate">{fav.favouriteMemberId.firstName}</span>
              </div>
              <div>
                <span
                  className="three-dots d-none d-sm-inline"
                  onClick={() => showFavourite(fav.favouriteMemberId._id)}
                >
                  &#8942;
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <MakeFavourite
        showFavourite={showfav}
        HideFavourite={HideFavourite}
        favouriteUserId={favouriteUserId}
        toggleFavourite={toggleFavourite}
        FavStatus={FavStatus}
      />
    </div>


  );

};
export default Favorites;
